/**
 * Stable diagnostic string for thrown/caught `unknown` values (logging,
 * Sentry, analytics). Unlike `JSON.stringify` alone, never returns `undefined`
 * (e.g. for functions `JSON.stringify` yields `undefined` without throwing).
 */
export function stringifyUnknownError(error: unknown): string {
  if (error instanceof Error) {
    return (
      error.message ||
      `[Error with no message, name="${error.name}", type=${error.constructor?.name}]`
    );
  }
  if (typeof error === "string") return error;
  if (error === null) return "null thrown";
  if (error === undefined) return "undefined thrown";
  try {
    const json = JSON.stringify(error);
    return json !== undefined
      ? json
      : `[non-serializable ${typeof error}: ${
          (error as { constructor?: { name?: string } })?.constructor?.name ??
          String(error)
        }]`;
  } catch {
    return String(error);
  }
}
